//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as Actions from './actions';
import { logToSentry } from "utils/networkErrorUtils";
import { has } from 'lodash';

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------


//  -- List chapter interactions ------




export const handleCreateOneWayDebate = (data) => async (dispatch) => {
    try {
        const videos = await apis.post('oneway_debate', `/createDebate`, {
            body: data
        });
        if (has(videos, "id")) {
            await dispatch(Actions.createOnewayDebate(videos));
        }
        return videos;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating one way debate',
                error,
                module: 'DEBATE',
                operation: 'CREATE_ORGANIZATION_WORD_DEBATE'
            });
        }
    }
};
export const handleUpdateOneWayDebate = (data) => async (dispatch) => {
    try {
        const videos = await apis.put('oneway_debate', `/updateDebate`, {
            body: data
        });
        if (has(videos, "id")) {
            await dispatch(Actions.updateOnewayDebate(videos));
        }
        return videos;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating one way debate',
                error,
                module: 'DEBATE',
                operation: 'UPDATE_ORGANIZATION_WORD_DEBATE'
            });
        }
        console.log(error,"error")
    }
};
export const handleSyncDebate = (data) => async (dispatch) => {
    try {
        const videos = await apis.post('oneway_debate', `/create_assignment`, {
            body: data
        });
        return videos;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'syncing debate',
                error,
                module: 'DEBATE',
                operation: 'SET_DATA'
            });
        }
        console.log(error,"error")
    }
};
export const handledeleteDebate = (id, classId) => async (dispatch) => {
    try {
        const data = await apis.post('oneway_debate', `/delete_assignment`, {
            body: {
                debate_id:id,
                class_id: classId
            }
        });
        return data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting debate',
                error,
                module: 'DEBATE',
                operation: 'DELETE_DEBATE'
            });
        }
        console.log(error,"error")
    }
};

export const handleDebateAI = async (data) => {
    try {
        const videos = await apis.post('oneway_debate', `/debate_ai`, {
            body: data
        });
        return videos;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'debating AI',
                error,
                module: 'DEBATE',
                operation: 'DELETE_ACTIVITY'
            });
        }
    }
};